var _style, _g, _g2, _g3, _g4, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#FFFFFF;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st4{display:inline;fill:none;stroke:#4C5159;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st5{display:inline;fill:none;stroke:#4C5159;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:2;}\r\n\t.st6{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:2;}\r\n\t.st7{fill:#4C5159;}\r\n\t.st8{font-family:'Montserrat-Bold';}\r\n\t.st9{font-size:7px;}\r\n\t.st10{display:inline;fill:#74E2F0;}\r\n\t.st11{display:inline;fill:#FBDA73;}\r\n\t.st12{display:inline;fill:#F08E70;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_119_",
    x: -218,
    y: -268.2,
    className: "st1",
    width: 500,
    height: 600.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "guideline",
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_419_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st3",
    d: "M51.1,18.6h2.5c0.6,0,1.1,0.5,1.1,1.1v26.1c0,0.6-0.5,1.1-1.1,1.1H10.4 c-0.6,0-1.1-0.5-1.1-1.1V19.6c0-0.6,0.5-1.1,1.1-1.1h15.5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_423_",
    className: "st3",
    x1: 9.3,
    y1: 40.7,
    x2: 54.7,
    y2: 40.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_422_",
    className: "st3",
    x1: 20.7,
    y1: 46.3,
    x2: 20.7,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_421_",
    className: "st3",
    x1: 42.8,
    y1: 46.3,
    x2: 42.8,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_420_",
    className: "st3",
    x1: 16.7,
    y1: 54,
    x2: 47,
    y2: 54
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_357_",
    className: "st3",
    d: "M16,37.9v-3.5c0-0.3,0.2-0.6,0.5-0.7l4.3-1.5v-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st3",
    d: "M29.3,37.9v-3.5c0-0.3-0.2-0.6-0.5-0.7l-4.3-1.5v-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st3",
    d: "M25.9,24.4c0-1.8-1.4-3.2-3.2-3.2c-1.8,0-3.2,1.4-3.2,3.2l0.3,3.9c0,0.5,0.3,1,0.8,1.2l1.6,1 h1l1.6-1c0.5-0.2,0.8-0.7,0.8-1.2L25.9,24.4z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_7_",
    className: "st3",
    points: "20.8,32.3 22,33.6 23.4,33.6 24.6,32.3  "
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_86_",
    className: "st3",
    x1: 13.2,
    y1: 37.9,
    x2: 32.4,
    y2: 37.9
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st4",
    d: "M43,16.2l-6,3.5c-0.1,0.1-0.2,0-0.2-0.1v-6.9c0-0.1,0.1-0.2,0.2-0.1l6,3.5 C43.1,16,43.1,16.1,43,16.2l-6,3.5c-0.1,0.1-0.2,0-0.2-0.1v-6.9c0-0.1,0.1-0.2,0.2-0.1l6,3.5C43.1,16,43.1,16.1,43,16.2z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_14_",
    className: "st4",
    x1: 34.3,
    y1: 29.3,
    x2: 48.9,
    y2: 29.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_29_",
    className: "st4",
    x1: 37.2,
    y1: 33,
    x2: 46,
    y2: 33
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_534_",
    className: "st4",
    d: "M48.8,22.4H32.2l-4.1,3.5c0,0-0.1,0-0.1,0V10.1c0-0.1,0.1-0.1,0.1-0.1h20.6 c0.1,0,0.1,0.1,0.1,0.1v12.2C48.9,22.4,48.9,22.4,48.8,22.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_123_",
    className: "st3",
    d: "M39.7,11H24.4v6.7c2.2-0.6,7.7,0.9,7.7,0.9s5.9-1.4,7.6-0.9V11z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_127_",
    className: "st3",
    x1: 17.5,
    y1: 11,
    x2: 46.9,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_128_",
    className: "st3",
    x1: 43.7,
    y1: 11,
    x2: 43.7,
    y2: 25.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_558_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_562_",
    className: "st3",
    d: "M15.9,53v-8.4c0-0.8,0.5-1.5,1.3-1.8l10.3-3.5v-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_561_",
    className: "st3",
    d: "M48.1,53v-8.4c0-0.8-0.5-1.5-1.3-1.8l-10.3-3.5v-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st3",
    d: "M24.3,20.5l0.7,9.3c0.1,1.3,0.8,2.4,1.9,3l3.8,2.5h2.5l3.9-2.5c1.1-0.6,1.9-1.7,1.9-3 l0.7-9.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_559_",
    className: "st3",
    points: "27.5,39.3 31.4,42.7 32.8,42.7 36.7,39.3  "
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_556_",
    className: "st4",
    x1: 12.1,
    y1: 53,
    x2: 51.9,
    y2: 53
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st4",
    d: "M31.4,42.7l-3.7,5.1c-0.1,0.1-0.3,0.1-0.4,0l-3-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st4",
    d: "M32.3,42.7l3.7,5.1c0.1,0.1,0.3,0.1,0.4,0l3-7.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_70_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st3",
    d: "M51.4,51.2H20.2c-3.3,0-6-2.7-6-6v0c0-3.3,2.7-6,6-6h31.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st3",
    d: "M19.2,48.2c0.8-0.8,1.2-1.8,1.2-3v0l0,0c0-1.2-0.5-2.2-1.2-3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_54_",
    className: "st3",
    x1: 21.9,
    y1: 43.2,
    x2: 49.5,
    y2: 43.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_50_",
    className: "st3",
    x1: 21.9,
    y1: 47.1,
    x2: 49.5,
    y2: 47.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    className: "st4",
    d: "M13.2,51.2H9.7c-0.1,0-0.2-0.1-0.2-0.2V13.1c0-0.1,0.1-0.2,0.2-0.2h31.5 c0.1,0,0.2,0.1,0.2,0.2v4.4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_59_",
    className: "st4",
    x1: 19.9,
    y1: 21.9,
    x2: 31.9,
    y2: 21.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_58_",
    className: "st4",
    x1: 19.9,
    y1: 26.9,
    x2: 28.3,
    y2: 26.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_69_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    className: "st3",
    d: "M51,31.4c0,3.8-3.2,7-8.6,7.4c-0.4,0-1.7-1-2.1-1c-0.4,0-1.8,1-2.3,1 c-5.3-0.4-8.5-3.6-8.5-7.4c0-3.8,3.1-7,8.5-7.4c0.4,0,1.8,2.2,2.2,2.2c0.4,0,1.8-2.3,2.2-2.2C47.9,24.4,51,27.5,51,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    className: "st3",
    d: "M40.4,26c0,0-0.5-5.9,3.8-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    className: "st3",
    d: "M40.7,21.5c0,0-2,0.8-3.4-0.1c-1.4-0.8-1.6-3-1.6-3s2-0.8,3.4,0.1 C40.4,19.4,40.7,21.5,40.7,21.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    className: "st5",
    d: "M46.7,19.2c4.7,2.2,7.9,7,7.9,12.5c0,2.1-0.5,4.2-1.3,6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_76_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_79_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st3",
    d: "M28,31.6V18.9l3.5-5.5c0.1-0.3,0.5-0.3,0.7,0l3.4,5.5v12.8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_81_",
    className: "st3",
    x1: 31.8,
    y1: 22.2,
    x2: 31.8,
    y2: 31.6
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_80_",
    className: "st3",
    points: "28,18.9 31.7,22.7 35.7,18.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_77_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st3",
    d: "M14.8,50.9c0-9.5,7.7-17.2,17.2-17.2c9.5,0,17.2,7.7,17.2,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    className: "st6",
    d: "M40.7,28.6c2.7,1.1,5.1,2.8,7.1,4.8c2,2,3.6,4.4,4.8,7.1c1.1,2.7,1.7,5.6,1.7,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_91_",
    className: "st6",
    d: "M9.8,49c0-3.1,0.6-6,1.7-8.7c1.1-2.7,2.8-5.1,4.8-7.1c2-2,4.4-3.6,7.1-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st3",
    d: "M38.1,34.7c2.6,4.2,4.2,9.9,4.2,16.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    className: "st3",
    d: "M26.4,34.7c-2.6,4.2-4.2,9.9-4.2,16.1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_441_",
    className: "st3",
    x1: 32,
    y1: 50.8,
    x2: 32,
    y2: 33.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_435_",
    className: "st3",
    x1: 17.4,
    y1: 42.7,
    x2: 47.2,
    y2: 42.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_93_",
    className: "st3",
    x1: 10.9,
    y1: 50.9,
    x2: 52.2,
    y2: 50.9
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_108_",
    className: "st4",
    x1: 29.7,
    y1: 16.2,
    x2: 33.8,
    y2: 16.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_82_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_111_",
    x: 29.4,
    y: 51.8,
    className: "st4",
    width: 5.4,
    height: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_110_",
    className: "st4",
    points: "40.4,51.8 23.7,51.8 22.6,49.4 22.6,42.2 41.6,42.2 41.6,49.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    className: "st4",
    d: "M45.5,27.6c0-7.4-6-13.4-13.4-13.4c-7.4,0-13.4,6-13.4,13.4c0,4.7,2.5,8.9,6.2,11.3v3.3h14.5 v-3.3C43.1,36.5,45.5,32.3,45.5,27.6z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_94_",
    className: "st4",
    x1: 22.6,
    y1: 47,
    x2: 30.8,
    y2: 47
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_118_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_121_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_126_",
    className: "st3",
    d: "M25.6,36.1v-3.3c0-0.3,0.2-0.6,0.5-0.7l4-1.4v-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_125_",
    className: "st3",
    d: "M38.3,36.1v-3.3c0-0.3-0.2-0.6-0.5-0.7l-4-1.4v-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_124_",
    className: "st3",
    d: "M35,23.3c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.1,1.4-3.1,3.1l0.3,3.7c0,0.5,0.3,0.9,0.8,1.2 l1.5,1h1l1.5-1c0.4-0.2,0.7-0.7,0.8-1.2L35,23.3z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_122_",
    className: "st3",
    points: "30.2,30.7 31.3,32 32.7,32 33.8,30.7  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_84_",
    className: "st5",
    d: "M18.9,40.8c-3.4-3.4-5.4-8-5.4-13.1c0-5.1,2.1-9.7,5.4-13.1c3.4-3.4,8-5.4,13.1-5.4 s9.7,2.1,13.1,5.4c3.4,3.4,5.4,8,5.4,13.1c0,5.1-2.1,9.7-5.4,13.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_143_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_576_",
    className: "st4",
    d: "M48.4,54H15.6c-0.3,0-0.6-0.3-0.6-0.6V10.6c0-0.3,0.3-0.6,0.6-0.6h32.7 c0.3,0,0.6,0.3,0.6,0.6v42.8C48.9,53.7,48.7,54,48.4,54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    className: "st4",
    d: "M42,15.4h2.6c0.1,0,0.2,0.1,0.2,0.2v31.8c0,0.1-0.1,0.2-0.2,0.2h-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    className: "st4",
    d: "M39.9,45.8c0,1.1-0.9,1.9-2.1,1.9H19.4c-0.1,0-0.2-0.1-0.2-0.2V15.5c0-0.1,0.1-0.2,0.2-0.2 H34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    className: "st4",
    d: "M39.9,45.9c0-1.3-0.9-2-1.8-2h-1.8V13.2h1.8c1,0,1.8,0.8,1.8,1.8V45.9z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_135_",
    className: "st4",
    x1: 28.3,
    y1: 12.5,
    x2: 34,
    y2: 12.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_134_",
    className: "st4",
    x1: 27.2,
    y1: 12.5,
    x2: 25.4,
    y2: 12.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_138_",
    className: "st4",
    x1: 23.1,
    y1: 21,
    x2: 33.4,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_137_",
    className: "st4",
    x1: 23.1,
    y1: 26,
    x2: 33.4,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_139_",
    className: "st4",
    x1: 23.1,
    y1: 31,
    x2: 33.4,
    y2: 31
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_140_",
    className: "st4",
    x1: 23.1,
    y1: 36,
    x2: 33.4,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_141_",
    className: "st4",
    x1: 23.1,
    y1: 41,
    x2: 33.4,
    y2: 41
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_146_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_152_",
    className: "st4",
    d: "M28.2,25.6l-6.2,3.6c-0.1,0.1-0.3,0-0.3-0.1V22c0-0.1,0.1-0.2,0.3-0.1l6.2,3.6 C28.3,25.4,28.3,25.6,28.2,25.6l-6.2,3.6c-0.1,0.1-0.3,0-0.3-0.1V22c0-0.1,0.1-0.2,0.3-0.1l6.2,3.6C28.3,25.4,28.3,25.6,28.2,25.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_117_",
    className: "st4",
    d: "M23.2,14.6v-3.5c0-0.1,0.1-0.2,0.2-0.2h26.2c0.1,0,0.2,0.1,0.2,0.2v15.9 c0,0.1-0.1,0.2-0.2,0.2h-3.5v2.6v3.5c0,0.3-0.3,0.4-0.5,0.2l-6.5-6.3h-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1112_",
    className: "st4",
    d: "M14.1,17.1V33c0,0.1,0.1,0.2,0.2,0.2h3.5v2.6v3.5c0,0.3,0.3,0.4,0.5,0.2l6.5-6.3h10 c0.1,0,0.2-0.1,0.2-0.2V17.1c0-0.1-0.1-0.2-0.2-0.2H14.4C14.2,16.9,14.1,17,14.1,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    className: "st4",
    d: "M8.5,53.2h19.7c0-2.2,1.8-3.9,3.9-3.9c2.2,0,3.9,1.8,3.9,3.9h19.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_114_",
    className: "st4",
    d: "M52.4,53.2l-1-6.8c0-0.1-0.1-0.2-0.2-0.2H34.5l-2.5,1l-2.5-1H12.8c-0.1,0-0.2,0.1-0.2,0.2 l-1,6.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_112_",
    className: "st4",
    points: "31.8,46.7 29.5,43.2 13,41.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_116_",
    className: "st4",
    points: "32.5,46.7 34.8,43.2 51.3,41.7  "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_120_",
    className: "st4",
    x1: 12.3,
    y1: 49.2,
    x2: 20.3,
    y2: 49.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_144_",
    className: "st4",
    x1: 38.7,
    y1: 15.1,
    x2: 44.3,
    y2: 15.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_129_",
    className: "st4",
    x1: 38.7,
    y1: 19.3,
    x2: 44.3,
    y2: 19.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_145_",
    className: "st4",
    x1: 38.7,
    y1: 23.5,
    x2: 44.3,
    y2: 23.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_258_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_269_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_275_",
    className: "st3",
    d: "M37.5,53.9v-3.5c0-0.3,0.2-0.6,0.5-0.7l4.3-1.5v-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_272_",
    className: "st3",
    d: "M50.9,53.9v-3.5c0-0.3-0.2-0.6-0.5-0.7l-4.3-1.5v-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_271_",
    className: "st3",
    d: "M47.4,40.5c0-1.8-1.4-3.2-3.2-3.2c-1.8,0-3.2,1.4-3.2,3.2l0.3,3.9c0,0.5,0.3,1,0.8,1.2 l1.6,1h1l1.6-1c0.5-0.2,0.8-0.7,0.8-1.2L47.4,40.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_270_",
    className: "st3",
    points: "42.3,48.3 43.5,49.6 44.9,49.6 46.1,48.3  "
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_268_",
    className: "st4",
    x1: 12.8,
    y1: 53.9,
    x2: 53.9,
    y2: 53.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_260_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_279_",
    className: "st3",
    d: "M18.5,53.9v-3.5c0-0.3,0.2-0.6,0.5-0.7l4.3-1.5v-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_277_",
    className: "st3",
    d: "M31.9,53.9v-3.5c0-0.3-0.2-0.6-0.5-0.7l-4.3-1.5v-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_262_",
    className: "st3",
    d: "M28.4,40.5c0-1.8-1.4-3.2-3.2-3.2c-1.8,0-3.2,1.4-3.2,3.2l0.3,3.9c0,0.5,0.3,1,0.8,1.2 l1.6,1h1l1.6-1c0.5-0.2,0.8-0.7,0.8-1.2L28.4,40.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_261_",
    className: "st3",
    points: "23.3,48.3 24.5,49.6 25.9,49.6 27.1,48.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_115_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_426_",
    className: "st3",
    d: "M17.1,28.1v-8.5c0-0.4,0.3-0.7,0.7-0.7h4.5c0.4,0,0.7,0.3,0.7,0.7v8.5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_427_",
    className: "st3",
    x1: 17.3,
    y1: 23.5,
    x2: 23,
    y2: 23.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_265_",
    className: "st4",
    d: "M22.7,13.6v-3.3c0-0.1,0.1-0.2,0.2-0.2h25c0.1,0,0.2,0.1,0.2,0.2v15.1c0,0.1-0.1,0.2-0.2,0.2 h-3.3v2.5v3.3c0,0.3-0.3,0.4-0.5,0.2l-6.2-6h-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_264_",
    className: "st4",
    d: "M30,16v15.1c0,0.1-0.1,0.2-0.2,0.2H19.7v2.5v3.3c0,0.3-0.3,0.4-0.5,0.2l-6.2-6h-2.7 c-0.1,0-0.2-0.1-0.2-0.2V16c0-0.1,0.1-0.2,0.2-0.2h19.6C29.9,15.8,30,15.9,30,16z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_256_",
    className: "st4",
    x1: 32.9,
    y1: 14.2,
    x2: 42.9,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_255_",
    className: "st4",
    x1: 32.9,
    y1: 18.2,
    x2: 42.9,
    y2: 18.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_254_",
    className: "st4",
    x1: 32.9,
    y1: 22.1,
    x2: 42.9,
    y2: 22.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_53_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_176_",
    className: "st4",
    d: "M16.1,37.4V17.2c0-1,0.8-1.8,1.8-1.8h6.5c1,0,1.8,0.8,1.8,1.8v14.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    className: "st4",
    d: "M29.1,30.4V12.6c0-1,0.8-1.8,1.8-1.8h1.9c1.1,0,1.9,0.9,1.9,1.9v17.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    className: "st4",
    d: "M37.7,31.5V16c0-1,0.8-1.8,1.8-1.8h5.1c1,0,1.8,0.8,1.8,1.8v20.2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_173_",
    className: "st4",
    x1: 18.6,
    y1: 19.4,
    x2: 23.7,
    y2: 19.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_172_",
    className: "st4",
    x1: 18.6,
    y1: 23.5,
    x2: 23.7,
    y2: 23.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_171_",
    className: "st4",
    x1: 18.6,
    y1: 27.6,
    x2: 23.7,
    y2: 27.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_170_",
    className: "st4",
    x1: 18.6,
    y1: 31.7,
    x2: 23.7,
    y2: 31.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_169_",
    className: "st4",
    x1: 18.6,
    y1: 35.8,
    x2: 21.4,
    y2: 35.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_168_",
    className: "st4",
    cx: 42,
    cy: 20.4,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st4",
    d: "M37.1,39.1c-1.3-2.1-3.7-3.4-6.3-3.4c-1.4,0-2.7,0.4-3.8,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    className: "st4",
    d: "M21,38.3c1.8,0,3.2,1.4,3.2,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    className: "st4",
    d: "M50.2,43.5h-0.2c-0.8-2.8-3.3-4.8-6.4-4.8c-1.3,0-2.5,0.4-3.6,1.1c-0.7-4.3-4.4-7.7-8.9-7.7 c-4.1,0-7.5,2.7-8.7,6.4c-0.5-0.1-1.1-0.2-1.6-0.2c-3.1,0-5.7,2.3-6.1,5.2h-1c-2.6,0-4.6,2.1-4.6,4.6v0.3c0,2.6,2.1,4.6,4.6,4.6 h36.5c2.6,0,4.6-2.1,4.6-4.6v-0.3C54.9,45.6,52.8,43.5,50.2,43.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_193_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_194_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_197_",
    className: "st3",
    d: "M54.8,48.1l0,4.3c0,0.2-0.1,0.3-0.3,0.3l-41.7,0l-3.5-2.3c-0.2-0.1-0.2-0.3,0-0.4l3.5-2.2 h41.7C54.7,47.8,54.8,48,54.8,48.1z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_196_",
    className: "st3",
    x1: 50.1,
    y1: 52.9,
    x2: 50.1,
    y2: 47.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_195_",
    className: "st3",
    x1: 13.7,
    y1: 52.9,
    x2: 13.7,
    y2: 47.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_186_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_85_",
    className: "st3",
    d: "M44.9,13.3v34.3h-7.4c-12.1,0-21.8-9.8-21.8-21.8V13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    className: "st3",
    d: "M44.9,47.6L44.9,47.6c-4.9,0-8.9-4-8.9-8.9v-7h6.8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_90_",
    className: "st3",
    cx: 22.6,
    cy: 21.6,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_178_",
    className: "st3",
    cx: 22.6,
    cy: 21.6,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_102_",
    className: "st3",
    cx: 38.1,
    cy: 21.6,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_98_",
    className: "st3",
    cx: 38.1,
    cy: 21.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_167_",
    className: "st3",
    d: "M49.7,11.1h-5.1c-8,0-14.4,4.7-14.4,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_149_",
    className: "st3",
    d: "M30.2,21.6c0-5.8-6.5-10.5-14.4-10.5h-5.1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_177_",
    className: "st3",
    x1: 16.5,
    y1: 11.1,
    x2: 44.6,
    y2: 11.1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_136_",
    className: "st3",
    points: "27.8,26.5 30.2,29 32.6,26.6  "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_180_",
    className: "st3",
    x1: 23.6,
    y1: 34.1,
    x2: 23.6,
    y2: 36.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_100_",
    className: "st3",
    x1: 28.5,
    y1: 34.1,
    x2: 28.5,
    y2: 36.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_181_",
    className: "st3",
    x1: 33.5,
    y1: 34.1,
    x2: 33.5,
    y2: 36.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_184_",
    className: "st3",
    x1: 26.2,
    y1: 39,
    x2: 26.2,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_183_",
    className: "st3",
    x1: 31.2,
    y1: 39,
    x2: 31.2,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_185_",
    className: "st3",
    x1: 29.3,
    y1: 43.8,
    x2: 29.3,
    y2: 45.8
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_188_",
    className: "st4",
    x1: 25.7,
    y1: 47.7,
    x2: 25.7,
    y2: 50.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_187_",
    className: "st4",
    x1: 28.6,
    y1: 47.7,
    x2: 28.6,
    y2: 50.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_189_",
    className: "st4",
    x1: 31.5,
    y1: 47.7,
    x2: 31.5,
    y2: 50.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_192_",
    className: "st4",
    x1: 36.3,
    y1: 47.7,
    x2: 36.3,
    y2: 50.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_191_",
    className: "st4",
    x1: 39.2,
    y1: 47.7,
    x2: 39.2,
    y2: 50.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_190_",
    className: "st4",
    x1: 42.1,
    y1: 47.7,
    x2: 42.1,
    y2: 50.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_158_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_610_",
    className: "st3",
    d: "M27.3,10.4H16.2c-1.9,0-3.4,1.5-3.4,3.4v10.8h4.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_205_",
    className: "st3",
    d: "M40.6,52.7h10.5c0,0,0.1,0,0.1-0.1v-42c0-0.1-0.1-0.2-0.2-0.2H16.2c2.2,0,3.4,1.7,3.4,3.4 v38.7c0,0.1,0.1,0.2,0.2,0.2h10.7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_203_",
    className: "st3",
    x1: 24.4,
    y1: 15.5,
    x2: 32.7,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_202_",
    className: "st3",
    x1: 24.4,
    y1: 22.1,
    x2: 46.2,
    y2: 22.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_201_",
    className: "st3",
    x1: 24.4,
    y1: 26.9,
    x2: 46.2,
    y2: 26.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_199_",
    className: "st3",
    x1: 24.4,
    y1: 31.7,
    x2: 46.2,
    y2: 31.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_163_",
    className: "st3",
    d: "M32.7,49.4v4c0,0.2,0.2,0.3,0.3,0.2l2.3-0.9l2.3,0.9c0.1,0.1,0.3,0,0.3-0.2v-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_496_",
    className: "st3",
    d: "M41.7,42.1c0,0.8-0.8,1.5-1.1,2.2c-0.3,0.7-0.3,1.8-0.8,2.3c-0.6,0.6-1.6,0.5-2.3,0.8 c-0.7,0.3-1.4,1.1-2.2,1.1c-0.8,0-1.5-0.8-2.2-1.1c-0.7-0.3-1.8-0.3-2.3-0.8c-0.6-0.6-0.5-1.6-0.8-2.3c-0.3-0.7-1.1-1.4-1.1-2.2 c0-0.8,0.8-1.5,1.1-2.2c0.3-0.7,0.3-1.8,0.8-2.3c0.6-0.6,1.6-0.5,2.3-0.8c0.7-0.3,1.4-1.1,2.2-1.1c0.8,0,1.5,0.8,2.2,1.1 c0.7,0.3,1.8,0.3,2.3,0.8c0.6,0.6,0.5,1.6,0.8,2.3C41,40.6,41.7,41.2,41.7,42.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_230_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_215_",
    x: 29.4,
    y: 52.2,
    className: "st4",
    width: 5.4,
    height: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_214_",
    className: "st4",
    points: "40.6,52.2 23.6,52.2 22.5,49.8 22.5,42.5 41.7,42.5 41.7,49.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_212_",
    className: "st4",
    d: "M45.7,27.8c0-7.5-6.1-13.5-13.5-13.5c-7.5,0-13.5,6.1-13.5,13.5c0,4.8,2.5,9,6.2,11.4v3.4 h14.7v-3.4C43.2,36.8,45.7,32.6,45.7,27.8z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_210_",
    className: "st4",
    x1: 22.5,
    y1: 47.4,
    x2: 30.8,
    y2: 47.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_228_",
    className: "st5",
    d: "M18.4,40c-3.2-3.5-5.1-8.2-4.9-13.4c0.2-5.1,2.5-9.7,5.9-12.9c3.5-3.2,8.2-5.1,13.4-4.9 c5.1,0.2,9.7,2.5,12.9,5.9c3.2,3.5,5.1,8.2,4.9,13.4c-0.2,5.1-2.5,9.7-5.9,12.9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_216_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_207_",
    className: "st3",
    x1: 32.1,
    y1: 18.3,
    x2: 32.1,
    y2: 23.7
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_206_",
    className: "st3",
    points: "29.6,20.3 32.1,17.7 34.7,20.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_217_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_219_",
    className: "st3",
    x1: 41.2,
    y1: 27.3,
    x2: 35.8,
    y2: 27.3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_218_",
    className: "st3",
    points: "39.2,24.8 41.7,27.4 39.2,29.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_221_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_224_",
    className: "st3",
    x1: 32.1,
    y1: 36.4,
    x2: 32.1,
    y2: 31
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_222_",
    className: "st3",
    points: "34.7,34.4 32.1,37 29.5,34.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_225_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_227_",
    className: "st3",
    x1: 23,
    y1: 27.3,
    x2: 28.4,
    y2: 27.3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_226_",
    className: "st3",
    points: "25,29.9 22.5,27.3 25,24.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_229_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_232_",
    className: "st4",
    d: "M32.1,34.7l22.7-11.2c0.2-0.1,0.2-0.3,0-0.4L32.1,12c-0.1,0-0.1,0-0.2,0L9.2,23.1 c-0.2,0.1-0.2,0.3,0,0.4l22.7,11.2C32,34.8,32,34.8,32.1,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_233_",
    className: "st4",
    d: "M18.1,30.3v10.4h7.5c2.3,0,4.5,0.8,6.2,2.4l0,0H32l0,0c1.7-1.5,3.9-2.4,6.2-2.4h7.7V30.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_231_",
    className: "st4",
    d: "M51.2,28.1v16.6l0,0c-0.9,1.5-1.4,3.2-1.4,5v2.4H54V46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_236_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_242_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_245_",
    className: "st3",
    d: "M55.6,42.7l0,4.4c0,0.2-0.1,0.3-0.3,0.3l-43.2,0l-3.6-2.3c-0.2-0.1-0.2-0.4,0-0.4l3.6-2.3 h43.2C55.5,42.4,55.6,42.6,55.6,42.7z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_244_",
    className: "st3",
    x1: 50.8,
    y1: 47.7,
    x2: 50.8,
    y2: 42.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_243_",
    className: "st3",
    x1: 13.1,
    y1: 47.7,
    x2: 13.1,
    y2: 42.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_240_",
    className: "st5",
    d: "M9.8,38.5c0-12.3,10-22.2,22.2-22.2c12.3,0,22.2,10,22.2,22.2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_310_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_235_",
    className: "st3",
    d: "M50,40.4l0-2.3l-5.3-0.7c-0.3-1.4-0.9-2.7-1.6-4l2.5-3.9l-3-3L38.7,29 c-1.2-0.8-2.6-1.3-3.9-1.6L34,23l-4.2,0l-1.1,4.4c-1.4,0.3-2.7,0.9-4,1.6l-3.9-2.5l-3,3l2.5,3.8c-0.8,1.2-1.3,2.6-1.6,4l-4.6,0.8 l0,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_289_",
    className: "st3",
    d: "M24.7,40.4c0-3.8,3.1-6.9,6.9-6.9c3.8,0,6.9,3.1,6.9,6.9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_241_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_266_",
    className: "st4",
    d: "M34.9,31.1l-6.2,3.6c-0.1,0.1-0.3,0-0.3-0.1v-7.1c0-0.1,0.1-0.2,0.3-0.1l6.2,3.6 C35,30.9,35,31.1,34.9,31.1l-6.2,3.6c-0.1,0.1-0.3,0-0.3-0.1v-7.1c0-0.1,0.1-0.2,0.3-0.1l6.2,3.6C35,30.9,35,31.1,34.9,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_252_",
    className: "st4",
    d: "M31.3,54.1h-4.2c-0.9,0-1.6-0.7-1.6-1.6l0,0c0-0.9,0.7-1.6,1.6-1.6h4.2 c0.9,0,1.6,0.7,1.6,1.6l0,0C32.9,53.4,32.2,54.1,31.3,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_250_",
    className: "st4",
    d: "M16.5,36.6h-3.4c-1.6,0-3-1.3-3-3v-4.4c0-1.6,1.3-3,3-3h3.4V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_248_",
    className: "st4",
    d: "M47.5,36.6h3.4c1.6,0,3-1.3,3-3v-4.4c0-1.6-1.3-3-3-3h-3.4V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_239_",
    className: "st4",
    d: "M32,52.6c8.5,0,15.5-7,15.5-15.5v-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_267_",
    className: "st4",
    d: "M42.6,31c0,6-4.8,10.8-10.8,10.8C25.8,41.8,21,37,21,31s4.8-10.8,10.8-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_238_",
    className: "st5",
    d: "M31.8,20.2c6,0,10.8,4.8,10.8,10.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_253_",
    className: "st4",
    d: "M47.5,28.1v-2.7c0-8.6-6.9-15.5-15.5-15.5h0c-8.6,0-15.5,6.9-15.5,15.5v2.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_309_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_305_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_274_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_281_",
    className: "st3",
    d: "M23.4,33.4c-0.9,0.9-2,1.4-3.4,1.4c-1.3,0-2.5-0.5-3.4-1.4c-0.9-0.9-1.4-2-1.4-3.4 c0-1.3,0.5-2.5,1.4-3.4s2.1-1.4,3.4-1.4c1.3,0,2.5,0.5,3.4,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_263_",
    className: "st3",
    d: "M20,25.3c-0.4-0.6-0.7-1.4-0.7-2.3c0-2.2,1.8-4,4-4c0.8,0,1.5,0.2,2.2,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_283_",
    className: "st3",
    d: "M23.6,19c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5v26.4c0,1.5-1.1,2.7-2.6,2.7 c-1.5,0-2.7-1.2-2.7-2.7c0-0.5,0.1-1,0.4-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    className: "st3",
    d: "M22.3,41.4c-0.6,0.3-1.2,0.4-1.9,0.4c-2.4,0-4.4-2-4.4-4.4c0-1.3,0.6-2.5,1.5-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_285_",
    className: "st3",
    d: "M25.6,45.3c-0.6,0.4-1.4,0.6-2.2,0.6c-2.4,0-4.3-1.9-4.3-4.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_280_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_303_",
    className: "st3",
    d: "M41,33.4c0.9,0.9,2,1.4,3.4,1.4c1.3,0,2.5-0.5,3.4-1.4c0.9-0.9,1.4-2,1.4-3.4 c0-1.3-0.5-2.5-1.4-3.4c-0.9-0.9-2.1-1.4-3.4-1.4c-1.3,0-2.5,0.5-3.4,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_301_",
    className: "st3",
    d: "M44.4,25.3c0.4-0.6,0.7-1.4,0.7-2.3c0-2.2-1.8-4-4-4c-0.8,0-1.5,0.2-2.2,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_287_",
    className: "st3",
    d: "M40.8,19c0-1.9-1.6-3.5-3.5-3.5S33.8,17,33.8,19v26.4c0,1.5,1.1,2.7,2.6,2.7 c1.5,0,2.7-1.2,2.7-2.7c0-0.5-0.1-1-0.4-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_286_",
    className: "st3",
    d: "M42.1,41.4c0.6,0.3,1.2,0.4,1.9,0.4c2.4,0,4.4-2,4.4-4.4c0-1.3-0.6-2.5-1.5-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_284_",
    className: "st3",
    d: "M38.8,45.3c0.6,0.4,1.4,0.6,2.2,0.6c2.4,0,4.3-1.9,4.3-4.3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_312_",
    className: "st3",
    d: "M26.5,27.1c0-2.1,1.7-3.8,3.8-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_314_",
    className: "st3",
    d: "M36.5,32.1c0-2.1,1.7-3.8,3.8-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_316_",
    className: "st3",
    d: "M38.3,41.7c0-2.1-1.7-3.8-3.8-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_313_",
    className: "st3",
    d: "M23.7,40.3c0-2.2,1.8-3.9,3.9-3.9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_311_",
    className: "st4",
    d: "M32,53.7C20,53.7,10.3,44,10.3,32S20,10.3,32,10.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_306_",
    className: "st5",
    d: "M32,10.3c12,0,21.7,9.7,21.7,21.7S44,53.7,32,53.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_320_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_319_",
    className: "st4",
    d: "M12.8,48.4V10.5c0-0.1,0.1-0.2,0.2-0.2h36.8c0.1,0,0.2,0.1,0.2,0.2v32.4 c0,0.1-0.1,0.2-0.2,0.2H18.1C15.2,43.1,12.8,45.5,12.8,48.4L12.8,48.4c0,2.9,2.4,5.3,5.3,5.3h33.1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_318_",
    className: "st4",
    x1: 22.7,
    y1: 46.5,
    x2: 48.9,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_317_",
    className: "st4",
    x1: 22.7,
    y1: 50.4,
    x2: 48.9,
    y2: 50.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_321_",
    className: "st4",
    d: "M18.1,46.2c1.3,0,2.3,1,2.3,2.3c0,1.3-1,2.3-2.3,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_524_",
    className: "st4",
    d: "M39.7,22.4c0-2.5-2-4.6-4.6-4.6c-1.3,0-2.4,0.5-3.2,1.4c-0.8-0.8-2-1.4-3.2-1.4 c-2.5,0-4.6,2-4.6,4.6c0,1.2,0.5,2.3,1.3,3.2l6.5,6.5l6.7-6.6c0.1-0.1,0.3-0.3,0.3-0.3C39.3,24.3,39.7,23.4,39.7,22.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_323_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_337_",
    className: "st4",
    d: "M28.4,32.9V22l3-4.7c0.1-0.2,0.5-0.2,0.6,0L35,22v10.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_333_",
    className: "st4",
    d: "M19.6,21.7c0,4.3,2.2,8,5.5,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_334_",
    className: "st5",
    d: "M43.8,21.7c0-6.7-5.4-12.1-12.1-12.1C25,9.6,19.6,15,19.6,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_332_",
    className: "st4",
    d: "M38.2,31.8c3.3-2.2,5.5-5.9,5.5-10.2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_330_",
    className: "st4",
    x1: 31.7,
    y1: 24.8,
    x2: 31.7,
    y2: 32.9
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_329_",
    className: "st4",
    points: "28.4,22 31.6,25.3 35,22  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_327_",
    className: "st4",
    d: "M50.1,54.4v-6.9c0,0,0-0.1-0.1-0.1H35.7c0,0-0.1,0-0.1,0.1v6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_326_",
    className: "st4",
    d: "M38.1,47.5l0-8.9c0.1-0.5,0.4-1.3,0.8-1.7l5.4-5.8c1.3-1.7,4.1,0.1,2.6,1.7l-4.3,6l2.1,0 l5.2-5.6c0,0,0.3-3.4,0.4-3.9L47.9,23c-0.4-1-0.5-2.2-0.1-3.3c0.3-0.8,0.7-1.5,1-1.7l4.3,10.7c0.2,0.4,0.1,6.2,0.1,6.2l-6,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_325_",
    className: "st4",
    d: "M13.9,54.4v-6.9c0,0,0-0.1,0.1-0.1h14.3c0,0,0.1,0,0.1,0.1v6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_324_",
    className: "st4",
    d: "M25.9,47.5l0-8.9c-0.1-0.5-0.4-1.3-0.8-1.7L19.7,31c-1.3-1.7-4.1,0.1-2.6,1.7l4.3,6l-2.1,0 l-5.2-5.6c0,0-0.3-3.4-0.4-3.9l2.5-6.2c0.4-1,0.5-2.2,0.1-3.3c-0.3-0.8-0.7-1.5-1-1.7l-4.3,10.7c-0.2,0.4-0.1,6.2-0.1,6.2l6,12.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_340_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_338_",
    className: "st4",
    cx: 32,
    cy: 39.9,
    r: 13.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_345_",
    className: "st4",
    cx: 32,
    cy: 39.9,
    r: 7.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_341_",
    className: "st4",
    x1: 27.8,
    y1: 11,
    x2: 35.6,
    y2: 26.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_339_",
    className: "st4",
    x1: 22.4,
    y1: 30.1,
    x2: 12.8,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_343_",
    className: "st4",
    x1: 35.9,
    y1: 11,
    x2: 31.8,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_342_",
    className: "st4",
    x1: 41.2,
    y1: 29.7,
    x2: 51.2,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_347_",
    className: "st4",
    x1: 32,
    y1: 28.9,
    x2: 32,
    y2: 31.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_346_",
    className: "st4",
    x1: 37.5,
    y1: 30.4,
    x2: 36.2,
    y2: 32.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_348_",
    className: "st4",
    x1: 41.5,
    y1: 34.4,
    x2: 39.2,
    y2: 35.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_350_",
    className: "st4",
    x1: 43,
    y1: 39.9,
    x2: 40.3,
    y2: 39.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_351_",
    className: "st4",
    x1: 41.5,
    y1: 45.4,
    x2: 39.2,
    y2: 44.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_354_",
    className: "st4",
    x1: 37.5,
    y1: 49.4,
    x2: 36.2,
    y2: 47.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_355_",
    className: "st4",
    x1: 32,
    y1: 50.9,
    x2: 32,
    y2: 48.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_356_",
    className: "st4",
    x1: 26.5,
    y1: 49.5,
    x2: 27.9,
    y2: 47.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_358_",
    className: "st4",
    x1: 22.5,
    y1: 45.5,
    x2: 24.8,
    y2: 44.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_359_",
    className: "st4",
    x1: 21,
    y1: 40,
    x2: 23.7,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_360_",
    className: "st4",
    x1: 22.4,
    y1: 34.5,
    x2: 24.8,
    y2: 35.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_361_",
    className: "st4",
    x1: 26.4,
    y1: 30.4,
    x2: 27.8,
    y2: 32.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_362_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_363_",
    className: "st3",
    d: "M29.2,35.7h2.7c0.2,0,0.4,0.2,0.4,0.4v8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_364_",
    className: "st3",
    x1: 29.9,
    y1: 44.1,
    x2: 34.8,
    y2: 44.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_367_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_353_",
    className: "st4",
    cx: 32,
    cy: 32,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_365_",
    className: "st4",
    cx: 36.4,
    cy: 16.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_371_",
    className: "st4",
    cx: 48.3,
    cy: 27.8,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_368_",
    className: "st4",
    cx: 20.3,
    cy: 20.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_366_",
    className: "st4",
    d: "M37.6,19.7c0.8,3.5,1.3,7.7,1.3,12.3c0,11.6-3.1,21-6.9,21c-3.8,0-6.9-9.4-6.9-21 c0-11.6,3.1-21,6.9-21c1,0,2,0.6,2.8,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_372_",
    className: "st4",
    d: "M45.8,30.4c-2.6,2.5-6.2,5.2-10.3,7.6c-10,5.8-19.7,7.8-21.7,4.5 c-1.9-3.3,4.7-10.7,14.7-16.5c10-5.8,19.7-7.8,21.7-4.5c0.4,0.7,0.4,1.7,0.1,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_373_",
    className: "st4",
    d: "M18.1,30.3c2.6,2.6,6.2,5.3,10.4,7.7c10,5.8,19.7,7.8,21.7,4.5c1.9-3.3-4.7-10.7-14.7-16.5 c-4-2.3-7.9-4-11.3-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_349_",
    className: "st5",
    d: "M16.4,20c-1.2,0.2-2.1,0.7-2.5,1.5c-1.1,1.9,0.6,5.2,4.3,8.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_380_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_375_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_382_",
    className: "st3",
    d: "M32.1,28.9l19.3-9.5c0.1-0.1,0.1-0.3,0-0.4L32.1,9.6c-0.1,0-0.1,0-0.2,0l-19.3,9.5 c-0.1,0.1-0.1,0.3,0,0.4l19.3,9.5C32,28.9,32,28.9,32.1,28.9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_384_",
    className: "st3",
    points: "39,33.9 43.8,33.9 43.8,25.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_383_",
    className: "st3",
    points: "20.2,25.1 20.2,33.9 25.7,33.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_378_",
    className: "st3",
    d: "M48.3,23.3v14.1l0,0c-0.8,1.3-1.2,2.7-1.2,4.2v2h3.6v-5.1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_389_",
    className: "st4",
    d: "M32.4,49.1L32.4,49.1c-3.2,0-5.8-2.6-5.8-5.8v-4.7c0-3.2,2.6-5.8,5.8-5.8l0,0 c3.2,0,5.8,2.6,5.8,5.8v4.7C38.1,46.5,35.5,49.1,32.4,49.1z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_388_",
    className: "st4",
    x1: 25.7,
    y1: 39.7,
    x2: 38.1,
    y2: 39.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_387_",
    className: "st4",
    x1: 32.4,
    y1: 35.2,
    x2: 32.4,
    y2: 37.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_385_",
    className: "st5",
    d: "M43.8,49.5c-3,3-7.2,4.9-11.8,4.9s-8.8-1.9-11.8-4.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_403_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_392_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_400_",
    className: "st3",
    d: "M29.1,30.7V21l2.7-4.2c0.1-0.2,0.4-0.2,0.5,0L35,21v9.8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_399_",
    x: 29.8,
    y: 40.2,
    className: "st3",
    width: 4.3,
    height: 2.4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_398_",
    className: "st3",
    points: "38.8,40.2 25.2,40.2 24.3,38.3 24.3,32.5 39.7,32.5 39.7,38.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_397_",
    className: "st3",
    d: "M42.9,20.7c0-6-4.8-10.8-10.8-10.8c-6,0-10.8,4.8-10.8,10.8c0,3.8,2,7.2,5,9.1v2.7h11.7 v-2.7C40.9,27.8,42.9,24.5,42.9,20.7z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_396_",
    className: "st3",
    x1: 24.3,
    y1: 36.3,
    x2: 31,
    y2: 36.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_395_",
    className: "st3",
    x1: 32.1,
    y1: 23.5,
    x2: 32.1,
    y2: 30.7
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_393_",
    className: "st3",
    points: "29.1,21 32,23.9 35,21  "
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_402_",
    className: "st4",
    x1: 32,
    y1: 42.7,
    x2: 32,
    y2: 54.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_401_",
    className: "st4",
    d: "M39.9,45.8c0,0,0.4,3.3-1.2,4.6c-1.7,1.3-4.8,0.3-4.8,0.3s-0.4-3.3,1.2-4.6 C36.8,44.7,39.9,45.8,39.9,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_405_",
    className: "st4",
    d: "M24.4,47.9c0,0-0.4,3.3,1.2,4.6c1.7,1.3,4.8,0.3,4.8,0.3s0.4-3.3-1.2-4.6 C27.5,46.9,24.4,47.9,24.4,47.9z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_408_",
    className: "st4",
    x1: 18,
    y1: 20.5,
    x2: 14.7,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_406_",
    className: "st4",
    x1: 18.9,
    y1: 15.7,
    x2: 15.5,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_409_",
    className: "st4",
    x1: 21.3,
    y1: 11.5,
    x2: 18.7,
    y2: 9.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_414_",
    className: "st4",
    x1: 42.7,
    y1: 11.5,
    x2: 45.3,
    y2: 9.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_415_",
    className: "st4",
    x1: 45.1,
    y1: 15.7,
    x2: 48.3,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_416_",
    className: "st4",
    x1: 46,
    y1: 20.4,
    x2: 49.3,
    y2: 20.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_417_",
    className: "st4",
    x1: 45.1,
    y1: 25.2,
    x2: 48.3,
    y2: 26.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_418_",
    className: "st4",
    x1: 42.7,
    y1: 29.4,
    x2: 45.3,
    y2: 31.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_430_",
    className: "st4",
    x1: 21.4,
    y1: 29.5,
    x2: 18.7,
    y2: 31.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_431_",
    className: "st4",
    x1: 18.9,
    y1: 25.4,
    x2: 15.7,
    y2: 26.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_413_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_412_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_429_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_442_",
    className: "st3",
    d: "M40,33.8c0.8,0.8,1.8,1.2,3,1.2c1.2,0,2.2-0.5,3-1.2c0.8-0.8,1.2-1.8,1.2-3 c0-1.2-0.5-2.2-1.2-3c-0.8-0.8-1.8-1.2-3-1.2c-1.2,0-2.2,0.5-3,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_439_",
    className: "st3",
    d: "M43,26.6c0.4-0.6,0.6-1.3,0.6-2c0-2-1.6-3.6-3.6-3.6c-0.7,0-1.4,0.2-1.9,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_432_",
    className: "st3",
    d: "M39.8,21c0-1.7-1.4-3.1-3.1-3.1c-1.7,0-3.1,1.4-3.1,3.1v18.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_433_",
    className: "st3",
    d: "M45.3,34.4c0.8,0.7,1.4,1.8,1.4,3v2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_437_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_446_",
    className: "st3",
    d: "M23.8,33.8C23,34.6,22,35,20.8,35c-1.2,0-2.2-0.5-3-1.2c-0.8-0.8-1.2-1.8-1.2-3 c0-1.2,0.5-2.2,1.2-3c0.8-0.8,1.8-1.2,3-1.2c1.2,0,2.2,0.5,3,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_445_",
    className: "st3",
    d: "M20.8,26.6c-0.4-0.6-0.6-1.3-0.6-2c0-2,1.6-3.6,3.6-3.6c0.7,0,1.4,0.2,1.9,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_444_",
    className: "st3",
    d: "M24,21c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1v18.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_443_",
    className: "st3",
    d: "M18.5,34.4c-0.8,0.7-1.4,1.8-1.4,3v2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_428_",
    className: "st3",
    d: "M26.1,28.3c0-1.9,1.5-3.4,3.4-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_425_",
    className: "st3",
    d: "M36,32.7c0-1.9,1.5-3.4,3.4-3.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_447_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_453_",
    className: "st3",
    x1: 23.8,
    y1: 44.6,
    x2: 41,
    y2: 44.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_404_",
    className: "st3",
    d: "M23.6,53.5h-3.3c-0.1,0-0.2-0.1-0.2-0.2V40.3c0-0.1,0.1-0.2,0.2-0.2h3.3 c0.1,0,0.2,0.1,0.2,0.2v13.1C23.8,53.4,23.7,53.5,23.6,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_411_",
    className: "st3",
    d: "M19.7,51.8H17c-0.1,0-0.2-0.1-0.2-0.2v-9.5c0-0.1,0.1-0.2,0.2-0.2h2.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_424_",
    className: "st3",
    d: "M16.6,49.7h-2.7c-0.1,0-0.2-0.1-0.2-0.2v-5.3c0-0.1,0.1-0.2,0.2-0.2h2.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_450_",
    className: "st3",
    d: "M40.8,53.5h3.3c0.1,0,0.2-0.1,0.2-0.2V40.3c0-0.1-0.1-0.2-0.2-0.2h-3.3 c-0.1,0-0.2,0.1-0.2,0.2v13.1C40.6,53.4,40.7,53.5,40.8,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_449_",
    className: "st3",
    d: "M44.8,51.8h2.7c0.1,0,0.2-0.1,0.2-0.2v-9.5c0-0.1-0.1-0.2-0.2-0.2h-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_448_",
    className: "st3",
    d: "M47.9,49.7h2.7c0.1,0,0.2-0.1,0.2-0.2v-5.3c0-0.1-0.1-0.2-0.2-0.2h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_407_",
    className: "st3",
    x1: 23.8,
    y1: 48.8,
    x2: 41,
    y2: 48.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_451_",
    className: "st5",
    d: "M13.3,38c-1-2.4-1.5-5.1-1.4-7.9c0.1-2.8,0.7-5.4,1.8-7.8c1.1-2.4,2.6-4.5,4.5-6.3 c1.9-1.8,4.1-3.2,6.5-4.1c2.4-1,5.1-1.5,7.9-1.4c2.8,0.1,5.4,0.7,7.8,1.8c2.4,1.1,4.5,2.6,6.3,4.5c1.8,1.9,3.2,4.1,4.1,6.5 c1,2.4,1.5,5.1,1.4,7.9c-0.1,2.8-0.7,5.4-1.8,7.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_434_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_518_",
    className: "st4",
    d: "M13.1,52.8V10.5c0-0.1,0.1-0.2,0.2-0.2h37.5c0.1,0,0.2,0.1,0.2,0.2v34.9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_517_",
    className: "st4",
    x1: 13.2,
    y1: 16.4,
    x2: 50.9,
    y2: 16.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_515_",
    className: "st4",
    x1: 15.6,
    y1: 13.5,
    x2: 18,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_514_",
    className: "st4",
    x1: 20,
    y1: 13.5,
    x2: 22.4,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_506_",
    className: "st4",
    x1: 24.4,
    y1: 13.5,
    x2: 26.7,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_512_",
    className: "st4",
    d: "M50.6,51.5l-2.2,2.2c-0.1,0.1-0.2,0.1-0.3,0L42.6,48c-0.1-0.1-0.1-0.2,0-0.3l2.2-2.2 c0.1-0.1,0.2-0.1,0.3,0l5.6,5.6C50.7,51.3,50.7,51.4,50.6,51.5z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_510_",
    className: "st4",
    x1: 41.3,
    y1: 44.3,
    x2: 43.2,
    y2: 46.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_507_",
    className: "st4",
    cx: 31.6,
    cy: 34.8,
    r: 13.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_612_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_619_",
    className: "st3",
    cx: 31.6,
    cy: 34.8,
    r: 10.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_618_",
    className: "st3",
    d: "M35.3,24.9c1.6,2.6,2.6,6.1,2.6,9.9c0,3.9-1,7.4-2.6,10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_617_",
    className: "st3",
    d: "M28.1,24.9c-1.6,2.6-2.6,6.1-2.6,9.9c0,3.9,1,7.4,2.6,10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_616_",
    className: "st3",
    x1: 31.6,
    y1: 24.2,
    x2: 31.6,
    y2: 45.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_615_",
    className: "st3",
    x1: 21,
    y1: 34.8,
    x2: 42.2,
    y2: 34.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_614_",
    className: "st3",
    x1: 22.6,
    y1: 29.8,
    x2: 40.9,
    y2: 29.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_613_",
    className: "st3",
    x1: 22.3,
    y1: 39.8,
    x2: 40.7,
    y2: 39.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_478_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_504_",
    className: "st4",
    d: "M27.6,23.5l-6,3.5c-0.1,0.1-0.2,0-0.2-0.1v-6.9c0-0.1,0.1-0.2,0.2-0.1l6,3.5 C27.8,23.3,27.8,23.4,27.6,23.5l-6,3.5c-0.1,0.1-0.2,0-0.2-0.1v-6.9c0-0.1,0.1-0.2,0.2-0.1l6,3.5C27.8,23.3,27.8,23.4,27.6,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_454_",
    className: "st4",
    d: "M54.1,54.1H9.9c-0.1,0-0.2-0.1-0.2-0.2V35.4c0-0.1,0.1-0.2,0.2-0.2h44.1 c0.1,0,0.2,0.1,0.2,0.2v18.5C54.3,54,54.2,54.1,54.1,54.1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_455_",
    className: "st4",
    points: "15.3,41.7 15.3,38.9 17.8,38.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_456_",
    className: "st4",
    points: "20.6,41.7 20.6,38.9 23.1,38.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_457_",
    className: "st4",
    points: "25.9,41.7 25.9,38.9 28.4,38.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_458_",
    className: "st4",
    points: "31.3,41.7 31.3,38.9 33.8,38.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_459_",
    className: "st4",
    points: "36.6,41.7 36.6,38.9 39.1,38.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_460_",
    className: "st4",
    points: "41.9,41.7 41.9,38.9 44.4,38.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_461_",
    className: "st4",
    points: "47.3,41.7 47.3,38.9 49.8,38.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_474_",
    className: "st4",
    points: "15.3,46.7 15.3,43.9 17.8,43.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_473_",
    className: "st4",
    points: "20.6,46.7 20.6,43.9 23.1,43.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_471_",
    className: "st4",
    points: "25.9,46.7 25.9,43.9 28.4,43.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_469_",
    className: "st4",
    points: "31.3,46.7 31.3,43.9 33.8,43.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_465_",
    className: "st4",
    points: "36.6,46.7 36.6,43.9 39.1,43.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_463_",
    className: "st4",
    points: "41.9,46.7 41.9,43.9 44.4,43.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_462_",
    className: "st4",
    points: "47.3,46.7 47.3,43.9 49.8,43.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_481_",
    className: "st4",
    points: "15.3,51.7 15.3,48.9 17.8,48.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_480_",
    className: "st4",
    points: "20.6,51.7 20.6,48.9 23.1,48.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_479_",
    className: "st4",
    points: "25.9,51.7 25.9,48.9 39.1,48.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_476_",
    className: "st4",
    points: "41.9,51.7 41.9,48.9 44.4,48.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_475_",
    className: "st4",
    points: "47.3,51.7 47.3,48.9 49.8,48.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_493_",
    className: "st4",
    d: "M15.1,33.1v-23c0-0.1,0.1-0.2,0.2-0.2h32.5c0.1,0,0.2,0.1,0.2,0.2v23"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_492_",
    className: "st4",
    x1: 15.2,
    y1: 15.6,
    x2: 47.9,
    y2: 15.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_491_",
    className: "st4",
    x1: 18.5,
    y1: 12.9,
    x2: 20.8,
    y2: 12.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_490_",
    className: "st4",
    x1: 22.1,
    y1: 12.9,
    x2: 24.4,
    y2: 12.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_489_",
    className: "st4",
    x1: 25.8,
    y1: 12.9,
    x2: 28,
    y2: 12.9
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_477_",
    className: "st4",
    points: "18.5,30.4 30.9,30.4 30.9,23.4  "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_502_",
    className: "st4",
    x1: 34.8,
    y1: 20.7,
    x2: 44.4,
    y2: 20.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_501_",
    className: "st4",
    x1: 34.8,
    y1: 24.7,
    x2: 44.4,
    y2: 24.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_503_",
    className: "st4",
    x1: 34.8,
    y1: 28.6,
    x2: 40.5,
    y2: 28.6
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_text",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_300_",
    transform: "matrix(1 0 0 1 -164.713 -76.8335)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "ONLINE "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.8,
    y: 7,
    className: "st7 st8 st9"
  }, "EDUCATION"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_302_",
    transform: "matrix(1 0 0 1 -75.4363 -76.8334)",
    className: "st7 st8 st9"
  }, "STUDENT")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_74_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_304_",
    transform: "matrix(1 0 0 1 16.2366 -76.8335)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "BACK TO"), /*#__PURE__*/React.createElement("tspan", {
    x: 0.8,
    y: 7,
    className: "st7 st8 st9"
  }, "SCHOOL"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_78_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_307_",
    transform: "matrix(1 0 0 1 109.2008 -76.8335)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "GLOBAL"), /*#__PURE__*/React.createElement("tspan", {
    x: -7.3,
    y: 7,
    className: "st7 st8 st9"
  }, "EDUCATION"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_87_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_308_",
    transform: "matrix(1 0 0 1 196.1154 -76.8332)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "CREATIVE"), /*#__PURE__*/React.createElement("tspan", {
    x: -0.9,
    y: 7,
    className: "st7 st8 st9"
  }, "TEACHING"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_142_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_328_",
    transform: "matrix(1 0 0 1 -164.4601 18.167)",
    className: "st7 st8 st9"
  }, "E-BOOK")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_147_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_331_",
    transform: "matrix(1 0 0 1 20.0336 18.1671)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "AUDIO"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.3,
    y: 7,
    className: "st7 st8 st9"
  }, "BOOK"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_56_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_336_",
    transform: "matrix(1 0 0 1 -71.6357 18.1673)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "CLOUD"), /*#__PURE__*/React.createElement("tspan", {
    x: -2.6,
    y: 7,
    className: "st7 st8 st9"
  }, "LIBRARY"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_198_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_352_",
    transform: "matrix(1 0 0 1 101.2136 18.167)",
    className: "st7 st8 st9"
  }, "SMART OWL")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_200_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_369_",
    transform: "matrix(1 0 0 1 197.0568 18.167)",
    className: "st7 st8 st9"
  }, "DIPLOMA")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_204_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_370_",
    transform: "matrix(1 0 0 1 -166.6429 114.6666)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "SHARING"), /*#__PURE__*/React.createElement("tspan", {
    x: -7,
    y: 7,
    className: "st7 st8 st9"
  }, "KNOWLEDGE"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_234_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_376_",
    transform: "matrix(1 0 0 1 -78.8755 114.6666)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "GRADUATE"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.6,
    y: 7,
    className: "st7 st8 st9"
  }, "CAP"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_237_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_377_",
    transform: "matrix(1 0 0 1 10.4554 114.6666)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "EDUCATION"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.5,
    y: 7,
    className: "st7 st8 st9"
  }, "APP"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_257_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_379_",
    transform: "matrix(1 0 0 1 102.4958 114.6663)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "LANGUAGE"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.1,
    y: 7,
    className: "st7 st8 st9"
  }, "COURSE"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_259_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_484_",
    transform: "matrix(1 0 0 1 201.1965 114.6666)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "GROUP"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.4,
    y: 7,
    className: "st7 st8 st9"
  }, "CLASS"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_315_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_485_",
    transform: "matrix(1 0 0 1 -161.3254 210.666)",
    className: "st7 st8 st9"
  }, "BRAIN")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_322_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_486_",
    transform: "matrix(1 0 0 1 -77.0412 210.6657)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "FAVORITE"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.4,
    y: 7,
    className: "st7 st8 st9"
  }, "LESSONS"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_335_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_487_",
    transform: "matrix(1 0 0 1 10.4553 210.6657)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "EDUCATION"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.7,
    y: 7,
    className: "st7 st8 st9"
  }, "FOR ALL"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_344_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_488_",
    transform: "matrix(1 0 0 1 108.9398 210.6657)",
    className: "st7 st8 st9"
  }, "SPORTS")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_374_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_494_",
    transform: "matrix(1 0 0 1 197.9248 210.666)",
    className: "st7 st8 st9"
  }, "SCIENCE")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_390_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_495_",
    transform: "matrix(1 0 0 1 -163.6837 306.6667)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "ONLINE"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.7,
    y: 7,
    className: "st7 st8 st9"
  }, "GRADUATION"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_410_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_497_",
    transform: "matrix(1 0 0 1 -82.7891 306.6667)",
    className: "st7 st8 st9"
  }, "INNOVATION")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_452_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_498_",
    transform: "matrix(1 0 0 1 20.7605 306.6667)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "BRAIN"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.3,
    y: 7,
    className: "st7 st8 st9"
  }, "TRAINING"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_438_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_499_",
    transform: "matrix(1 0 0 1 103.4795 306.6667)",
    className: "st7 st8 st9"
  }, "RESEARCH")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_482_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_500_",
    transform: "matrix(1 0 0 1 200.2106 306.6667)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8 st9"
  }, "ONLINE"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.3,
    y: 7,
    className: "st7 st8 st9"
  }, "TUTORIALS"))))), /*#__PURE__*/React.createElement("g", {
    id: "headline",
    className: "st0"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_61_",
    className: "st10",
    cx: -133.5,
    cy: -208.4,
    r: 18.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_60_",
    className: "st11",
    cx: -110.1,
    cy: -208.4,
    r: 18.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_63_",
    className: "st12",
    cx: -122.7,
    cy: -190.1,
    r: 18.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_505_",
    transform: "matrix(1 0 0 1 -183.7552 -194.0852)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#231F20",
      fontFamily: "'Oswald-Bold'",
      fontSize: "22.512px"
    }
  }, "FLAT "), /*#__PURE__*/React.createElement("tspan", {
    x: 45.5,
    y: 0,
    style: {
      fill: "#231F20",
      fontFamily: "'Oswald-Light'",
      fontSize: "22.512px"
    }
  }, "LINE "), /*#__PURE__*/React.createElement("tspan", {
    x: 83.9,
    y: 0,
    style: {
      fill: "#231F20",
      fontFamily: "'Oswald-Bold'",
      fontSize: "22.512px"
    }
  }, "ICONS"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "XMLID_508_",
    transform: "matrix(1 0 0 1 82.5865 -193.9056)",
    style: {
      fill: "#231F20",
      fontFamily: "'Oswald-Light'",
      fontSize: "16.1735px"
    }
  }, "EDUCATION &amp; KNOWLEDGE"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade);
export default __webpack_public_path__ + "static/media/grade.ef0c340708c41e32859015468d2e8904.svg";
export { ForwardRef as ReactComponent };